import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Theme } from '../../styles/theme.mjs';
import GlobalStyles from '../../styles/GlobalStyles.mjs';

const KThemeProvider = props => {
  const mergedTheme = {
    ...Theme,
    ...(props.appTheme ?? {})
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: mergedTheme
  }, (props.useGlobalStyles ?? true) && /*#__PURE__*/React.createElement(GlobalStyles, null), props.children);
};

export { KThemeProvider };
